import Accordioncommon from "@frameworks/web/components/generic/Accordion/accordion";
import React from "react";
import { ActivatedSegemntData } from "../../constant";
var BrokerageSegments = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement(Accordioncommon, { AccordionArray: ActivatedSegemntData, parentClass: "common-accordian-small-content  small-accordion-background mt-4" })));
};
export default BrokerageSegments;
